import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Account = props => (
  <button
    className={`account ${props.expanded ? 'active' : ''}`}
    onClick={props.onClick}
  >
    <FontAwesomeIcon icon={['fas', 'user']} />
    {props.firstName}
    <FontAwesomeIcon icon={['fas', 'caret-down']} />
  </button>
);

export default Account;

Account.propTypes = {
  onClick: PropTypes.func,
  firstName: PropTypes.string,
  expanded: PropTypes.bool,
};

Account.defaultProps = {
  expanded: false,
  firstName: 'User',
  onClick: () => {
    this.setState(prevState => ({
      accountToggle: !prevState.burgerToggle,
    }));
  },
};
